
export const products = {
  'product.categories': 'Categorías de productos',
  'explore.solutions': 'Explore nuestra amplia gama de soluciones audiovisuales profesionales',
  'view.video': 'Ver video de descripción del producto',
  // Product categories
  'AV Over IP': 'AV Sobre IP',
  'ReAX Control': 'Control ReAX',
  'Meeting Room Solutions': 'Soluciones para Salas de Reuniones',
  'Converters/Scalers': 'Convertidores/Escaladores',
  'Audio Products': 'Productos de Audio',
  'HDMI Switchers': 'Conmutadores HDMI',
  'IPBaseT': 'IPBaseT',
  'HDBaseT Products': 'Productos HDBaseT',
  // Product descriptions
  'Complete AV distribution solution with ultra-low latency': 'Solución completa de distribución AV con latencia ultra-baja',
  'Professional control system solutions': 'Soluciones profesionales de sistemas de control',
  'Complete solutions for modern meeting spaces': 'Soluciones completas para espacios de reuniones modernos',
  'Professional format conversion and scaling solutions': 'Soluciones profesionales de conversión y escalado de formato',
  'Professional audio processing and playback solutions': 'Soluciones profesionales de procesamiento y reproducción de audio',
  'Professional HDMI switching and distribution solutions': 'Soluciones profesionales de conmutación y distribución HDMI',
  'Advanced IP-based AV distribution platform': 'Plataforma avanzada de distribución AV basada en IP',
  'Professional HDBaseT distribution solutions': 'Soluciones profesionales de distribución HDBaseT',
  // Group-related translations
  'group.not.found': 'Grupo no encontrado',
  'back.to.avoip': 'Volver a opciones AVOIP',
  'back.to.reax': 'Volver a opciones de Control ReAX',
  'back.to.audio': 'Volver a opciones de Audio',
  'back.to.categories': 'Volver a categorías',
  // Product detail page translations
  'product.not.found': 'Producto no encontrado',
  'return.to.home': 'Volver al inicio',
  'back.to.product.group': 'Volver al grupo de productos',
  'overview': 'Descripción general',
  'full.description': 'Descripción completa',
  'features': 'Características',
  'specifications': 'Especificaciones',
};
